import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  MIRRORS_LIST_JS_MAIN_ROUTE_NAME,
  MIRRORS_LIST_NO_JS_MAIN_ROUTE_NAME,
  MIRRORS_LIST_PERMISSIONS,
} from '@modules/mirrors-list/constants';
import {
  MIRRORS_LIST_EDIT_JS_ROUTE_NAME,
  MIRRORS_LIST_EDIT_NO_JS_ROUTE_NAME,
  TRANSLATION_GROUP_MIRRORS_EDIT,
} from '@modules/mirrors-list/submodules/edit/constants';
import getTranslationKeys from '@modules/mirrors-list/submodules/edit/translations';

export class MirrorsListEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(MIRRORS_LIST_JS_MAIN_ROUTE_NAME, {
      name: MIRRORS_LIST_EDIT_JS_ROUTE_NAME,
      path: ':mirrorsNamespace/edit/:id',
      permission: MIRRORS_LIST_PERMISSIONS.EDIT,
      component: () => import('@modules/mirrors-list/submodules/edit/pages/MirrorsListEditPage/MirrorsListEditPage.vue'),
    });

    router.addChildRoute(MIRRORS_LIST_NO_JS_MAIN_ROUTE_NAME, {
      name: MIRRORS_LIST_EDIT_NO_JS_ROUTE_NAME,
      path: ':mirrorsNamespace/edit/:id',
      permission: MIRRORS_LIST_PERMISSIONS.EDIT,
      component: () => import('@modules/mirrors-list/submodules/edit/pages/MirrorsListEditPage/MirrorsListEditPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_MIRRORS_EDIT, getTranslationKeys);
  }
}
